import { render, staticRenderFns } from "./detail-flower.vue?vue&type=template&id=3c4ac355&scoped=true&"
import script from "./detail-flower.vue?vue&type=script&lang=js&"
export * from "./detail-flower.vue?vue&type=script&lang=js&"
import style0 from "./detail-flower.vue?vue&type=style&index=0&id=3c4ac355&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4ac355",
  null
  
)

export default component.exports